import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
const badgeVariants = cva("inline-flex items-center justify-center rounded-full border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden", {
  variants: {
    variant: {
      default: "border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/90",
      secondary: "border-transparent bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90",
      destructive: "border-transparent bg-destructive text-white [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
      outline: "text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
      /** The filled monospaced pill: DÉMO beside the piano name. */
      mono: "border-transparent bg-primary text-primary-foreground font-mono text-[10px] tracking-[0.08em] uppercase px-[7px] py-0.5",
      /** The hollow monospaced pill: OPTION beside an optional measurement. */
      monoOutline: "border-input text-ptl-ink-3 font-mono text-[9.5px] tracking-[0.06em] uppercase px-1.5 py-px"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
function Badge(t0) {
  const $ = _c(12);
  let className;
  let props;
  let t1;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      asChild: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = variant;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    variant = $[4];
  }
  const asChild = t1 === undefined ? false : t1;
  const Comp = asChild ? Slot : "span";
  let t2;
  if ($[5] !== className || $[6] !== variant) {
    t2 = cn(badgeVariants({
      variant
    }), className);
    $[5] = className;
    $[6] = variant;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== Comp || $[9] !== props || $[10] !== t2) {
    t3 = <Comp data-slot="badge" className={t2} {...props} />;
    $[8] = Comp;
    $[9] = props;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export { Badge, badgeVariants };